import { CommonModule } from '@angular/common';
import type { AfterViewInit, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, ViewChild, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import type { PalantirSize } from '../../shared/interfaces/sizes.interface';
import { PalantirIconComponent } from '../icon/icon.component';
import type { PalantirIcon } from '../icon/icon.type';

@Component({
  selector: 'palantir-expandable-input',
  templateUrl: './expandable-input.component.html',
  styleUrls: ['./expandable-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PalantirIconComponent, ReactiveFormsModule],
})
export class PalantirExpandableInputComponent implements AfterViewInit {
  @ViewChild('inputElement') public inputElement!: ElementRef<HTMLInputElement>;

  @Input() public control: FormControl<any> = new FormControl('');

  @Input() public size: PalantirSize = 'base';

  @Input() public icon: PalantirIcon = 'search-outline';

  @Input() public placeholderText = 'Pesquisar...';

  @Input() public growTo: 'left' | 'right' = 'right';

  public isOnFocus = signal<boolean>(false);

  public inputLength = signal<number>(0);

  public ngAfterViewInit(): void {
    this.inputElement.nativeElement.addEventListener('input', (inputEvent) => {
      const value = (inputEvent.target as HTMLInputElement).value;
      this.inputLength.set(value.length);

      if (!value.length && !this.isOnFocus()) {
        this.inputElement.nativeElement.blur();
      }
    });
  }

  public onMouseLeave(): void {
    if (!this.isOnFocus()) {
      this.inputElement.nativeElement.blur();
    }
  }

  public onFocus(): void {
    this.isOnFocus.set(true);
  }

  public onBlur(): void {
    this.isOnFocus.set(false);
  }
}
